// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"56fd266b","187":"3d696594","392":"b987fb73","417":"d40dc611","523":"027ecc96","625":"54a0beb6","714":"1ebb55e0","787":"64841077","968":"5d74854f"}[chunkId] + ".chunk.js";
};